<template>
	<view class="index-wrap">
		<view class="content-title">
			<view class="title">唐山烟草配送商户端</view>
		</view>
		<!-- 今日配送订单 -->
		<u-popup :show="popupShow" mode="center">
			<myHasOrder></myHasOrder>
		</u-popup>
		
	</view>
	
</template>

<script>
	export default {
		data() {
			return {
				popupShow: true,
			}
		},
		onLoad() {
		},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .u-popup__content{
		width: 90%;
		border-radius: 8rpx;
		border:1px solid #707070;
	}
	/deep/ .u-popup__content{
		max-height: 1000rpx;
		overflow-y: auto;
	}
	.content-title{
		width: 100%;
		height: 176rpx;
		background-color: #1F9F4C;
		.title{
			color: #FFFFFF;
			line-height: 88rpx;
			padding-top: 88rpx;
			padding-left: 32rpx;
			letter-spacing: 3rpx;
			font-weight: lighter;
		}
	}
</style>
